import { useParams } from 'react-router-dom';

export const useNumericParam = (paramName: string): number | undefined => {
  const params = useParams();
  const id = Number(params[paramName]);

  if (Number.isNaN(id)) {
    return undefined;
  }

  return id;
};
